<template>
  <layout-view navTitle="Фильтры">
    <template v-slot:nav>
      <portal to="back">
        <v-btn icon @click="$router.push('../')">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </portal>
      <div class="px-4">
        <text-field name="Название" :value.sync="filter.tagName"/>

        <v-btn small block depressed color="silver" @click="tag={}">
          Создать тэг
        </v-btn>
      </div>
    </template>
    <template v-slot:content="{height}">

      <n-table-view
        ref="table"
        name="Список"
        :genRequestBuilder="genRequestBuilder"
        :height="height"
        :headers="[
            { text: 'ID', value:'id', sortable: true},
            { text: 'Название', value:'name', sortable: true},
            { text: 'Длительность (дней)', value:'durationDays', sortable: true},
            { text: 'Тип', value:'type', sortable: true},
            { text: 'Цвет', value:'color', sortable: false},
          ]"
      >
        <template v-slot:item="{ item }">
          <tr @click="tag=item">
            <td>{{ item.id }}</td>
            <td>{{ item.name }}</td>
            <td>{{ item.durationDays ? item.durationDays : '-' }}</td>
            <td>{{ item.type === 'user' ? 'Пользователь' : item.type === 'medPlan' ?  'Мед.план' : '-'}}</td>
            <td>
              <chip v-if="item.color" :color="item.color"></chip>
            </td>
          </tr>
        </template>
      </n-table-view>
      
      <tag-settings :tag.sync="tag"  @update="$refs.table.load()"/>
    </template>
  </layout-view>
</template>

<script>
import LayoutView from "@/components/LayoutView";
import NTableView from "@/componentsV2/base/NTableView.vue";
import TagSettings from "@/views/Tag/components/TagSettings.vue";
import TextField from "@/componentsV2/base/TextField.vue";
import Chip from "@/componentsV2/base/Chip.vue";


import {
  Entity_Tag,
} from "../../../EntityStoreCacheService";



export default {
  components: {
    NTableView,
    LayoutView,
    TagSettings,
    TextField,
    Chip 
  },

  data:()=>({
    dateFrom:null,
    dateTo:null,
    tag: null,
    filter: {
      dateFrom: null,
      dateTo: null,
      tagName: null
    }
  }),
  watch:{
    filter: {
      handler() {
        this.$refs.table.load();
      },
      deep: true,
    }
  },
  methods:{
    genRequestBuilder(page, onPage, sortFields){
      let rb = new Entity_Tag()
        .selects(Entity_Tag.id)
        .selects(Entity_Tag.name)
        .selects(Entity_Tag.durationDays)
        .selects(Entity_Tag.color)
        .selects(Entity_Tag.type)

  
        rb.page(page).onPage(onPage)

        if(this.filter.tagName)
          rb.filterAnd([Entity_Tag.entity, Entity_Tag.name].join('.')+' LIKE ?','%'+this.filter.tagName+'%');

        sortFields.forEach(v=>{
          rb.order(v.field, v.isAsc)
        })

        return rb;
    },
  }
}
</script>